<template>
	<div class="mall-order-center">
		<div class="container">
			<div class="status-list">
				<div class="status-list-box">
					<div class="status-item" v-for="(v,k) in status_list" :key="`s`+k" :class="{active:form_data.status===k}" @click="change_status(k)">
						{{v.name}} <template v-if="v.count>0||true">({{v.count}})</template>
					</div>
				</div>
				<div class="filter-box">
					<div class="filter-item">
						<Poptip trigger="hover" placement="bottom">
							<template #content>
								<div class="cate-box">
									<div v-for="(item,index) in orderby_list" :class="['item',{active:item.value === form_data.order_type}]" :key="index" @click="onOrderClick(item)">{{ item.name }}</div>
								</div>
							</template>
							{{ curr_order || '列表排序' }}<Icon type="ios-arrow-down" />
						</Poptip>
					</div>
					<div class="filter-item">
						<Poptip trigger="hover" placement="bottom">
							<template #content>
								<div class="cate-box">
									<div class="item" :class="{active:!form_data.cate_id}" @click="onCateClick('')">全部分类</div>
									<div v-for="(item,index) in cate_list" :class="['item',{active:item.id === form_data.cate_id}]" :key="index" @click="onCateClick(item.id)">{{ item.name }}</div>
								</div>
							</template>
							{{ curr_cate }}<Icon type="ios-arrow-down" />
						</Poptip>
					</div>
					<div class="search">
						<img src="../../assets/images/icon-search.png" alt="" class="icon-search">
						<input type="text" placeholder="搜索订单号或商品名称" v-model="form_data.keyword" class="input" @keyup.enter="search">
					</div>
				</div>
			</div>

			<template v-if="order_list.length>0">
				<div class="list">
					<div class="item">
						<div class="th">
							<div class="info">产品信息</div>
							<div class="quantity">数量</div>
							<div class="amount">订单金额</div>
							<div class="status">订单状态</div>
							<div class="action">操作</div>
						</div>
					</div>
					<div class="item td" v-for="(v,k) in order_list"  :key="`or`+k" @click="form_data.status === 'service' ? go2service(v) : go2detail(v.uuid)">
						<div class="title">
							{{ form_data.status === 'service' ? '售后单号：' + v.refund_no : '订单号：' + v.order_no }}
						</div>
						<div class="content td">
							<div class="info" >
								<div v-for="(vv, kk) in displayGoods(v)" class="sub-info" :key="`si`+kk">
									<div class="left">
										<img :src="vv.product_image|default_img" alt="" class="image">
									</div>
									<div class="right">
										<div class="sub-name">{{vv.product_name}}</div>
                    <div v-if="vv.product && vv.product.param" class="sub-quantity">款号：{{vv.product.param.filter(item=>item.key === '款号')[0].value ||'-'}}</div>
                    <div class="sub-quantity">分类:{{ vv.category_name_cn ||'-' }}</div>
										<div class="sub-quantity">尺码：{{vv.spec_info}}</div>
                    <div v-if="vv.product && vv.product.sex" class="sub-quantity">性别：{{vv.product.sex|sex_filter}}</div>
                    <div class="pre-sale-line" v-if="vv.product && vv.product.sale_mode == 1">
                      <div class="pre-sale-box">
                        <div class="pre-tag">预售</div>
                        <div class="pre-delivery-time" v-if="['unpaid','wait_delivery'].includes(v.status_text)">{{ vv.product.presale_delivery_type == 2 ? `${vv.product.presale_promised_date}前发货` : calcRemainDays(v.create_time, vv.product.presale_delivery_days) }}</div>
                      </div>
                    </div>
                    <div class="product-btn-box" v-if="[1, 6].includes(v.status)">
                      <div class="after-sale-btn" @click.stop="onApplyService(vv,v)">申请售后</div>
                    </div>
									</div>
								</div>
							</div>
							<div class="quantity">
								{{ form_data.status === 'service' ? (v.new_spec_quantity ? v.new_spec_quantity : (v.goods ? v.goods.quantity : '-')) : v.quantity }}
							</div>
							<div class="amount">
								￥{{ form_data.status === 'service' ? (v.real_money || v.apply_money || v.money || 0) : v.total_price }}
							</div>
							<div class="status" :class="oc(v)">
								{{v.status_name}}
							</div>
							<div class="action">
								<div class="btn btn-pay" v-if="v.status_text === 'unpaid' && form_data.status !== 'service'" @click.stop="pay(v)">立即付款</div>
								<div class="btn btn-pay" v-if="v.status_text === 'unpaid' && form_data.status !== 'service'" @click.stop="cancel(v.uuid)">取消订单</div>
								<div class="btn btn-pay" v-if="v.status_text === 'wait_confirm' && form_data.status !== 'service'" @click.stop="confirm(v.uuid)">确认收货</div>
                <div class="btn btn-pay" v-if="v.status_text === 'complete' && form_data.status !== 'service'" @click.stop="onOrderEvaluate(v.uuid)">评价订单</div>
                <div class="btn-customer" v-if="form_data.status !== 'service'" @click.stop="showChat(v)">联系卖家</div>
                  <div class="btn btn-pay" v-if="form_data.status === 'service'" @click.stop="go2service(v)">售后详情</div>
								<!--
                <div class="btn btn-pay" v-if="v.status_text === 'complete' && !v.tax" @click.stop="onApplyTax(v)">申请开票</div>
                <div class="btn btn-pay" v-if="v.status_text === 'complete' && v.tax" @click.stop="onViewTax(v.tax)">{{v.tax.tax_file ? '查看发票' : '开票处理中'}}</div>
								-->
							</div>
						</div>

					</div>
				</div>
				<Page :current="page" :page-size="size"  :total="total" @on-change="changePage" show-total style="margin-top: 20px;"  show-sizer @on-page-size-change="changeSize" :page-size-opts="[5, 10, 20]"></Page>
			</template>
			<template v-else>
				<img src="../../assets/images/no-data.png" style="width:300px;display: block;margin:0 auto;" alt="">
			</template>

			<popup :show.sync="is_popup_show" width="490px" height="320px" @on-close="close">
				<h2>填写物流单号</h2>
				<div class="form">
					<div class="form-group">
						<div class="form-label">快递名称：</div>
						<div class="form-control">
							<select class="input" placeholder="请输入快递名称" v-model="form_data_send.logistics_name" @change="onChangeLogistics">
								<option
                v-for="(item, index) in logistics"
                :key="index"
                :value="item"
                >
                {{ item }}
                </option>
							</select>
						</div>
					</div>
					<div class="form-group">
						<div class="form-label">快递单号：</div>
						<div class="form-control">
							<input type="text" class="input" placeholder="请输入快递单号" v-model="form_data_send.logistics_no" />
						</div>
					</div>
					<div class="btn-submit" @click="save">保存</div>
				</div>
			</popup>
      <popup :show.sync="show_tax_form" width="490px" :height="form_data_tax.type == '2' ?'650px' : '320px'" @on-close="closeTaxForm">
				<h2>申请开票</h2>
				<div class="form">
          <div class="form-group">
						<div class="form-label">开票类型：</div>
						<div class="form-control">
							<RadioGroup v-model="form_data_tax.type">
                <Radio :label="1">个人</Radio>
                <Radio :label="2">企业</Radio>
              </RadioGroup>
						</div>
					</div>
					<div class="form-group">
						<div class="form-label">发票抬头：</div>
						<div class="form-control">
							<input type="text" class="input" placeholder="请输入发票抬头" v-model="form_data_tax.title" />
						</div>
					</div>
          <template v-if="form_data_tax.type == 2">
            <div class="form-group">
              <div class="form-label">纳税人识别号：</div>
              <div class="form-control">
                <input type="text" class="input" placeholder="请输入纳税人识别号" v-model="form_data_tax.tax_number" />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">公司地址：</div>
              <div class="form-control">
                <input type="text" class="input" placeholder="请输入公司地址" v-model="form_data_tax.company_address" />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">电话：</div>
              <div class="form-control">
                <input type="text" class="input" placeholder="请输入电话号码" v-model="form_data_tax.phone" />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">开户行：</div>
              <div class="form-control">
                <input type="text" class="input" placeholder="请输入开户行" v-model="form_data_tax.bank_name" />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">银行账号：</div>
              <div class="form-control">
                <input type="text" class="input" placeholder="请输入银行账号" v-model="form_data_tax.bank_account" />
              </div>
            </div>
          </template>
					<div class="btn-submit" @click="saveTax">保存</div>
				</div>
			</popup>
			
			<Chat ref="chat"></Chat>
		</div>
	</div>
</template>

<script>
import {
  applyTax,
  MallCancelOrder,
  MallConfirmOrder,
  MallOrderCateList,
  MallOrderCount,
  MallOrderList,
  MallOrderServiceList,
  Profile,
  SendFabric
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import logistics from "@/utils/logistics";
import { calcRemainDays } from "@/utils/util.js";
import axios from "axios";
const form_data_send = {
  logistics_name: "",
  logistics_no: "",
  uuid: "",
};
export default {
  name: "OrderCenter",
  components: {
    Popup,
  },
  data() {
    return {
      size: 10,
      page: 1,
      total: 0,
      form_data: {
        keyword: "",
        status: "all",
        order_type: "desc",
        cate_id: "",
      },
      cate_list: [],
      curr_cate: "全部分类",
      status_list: {
        all: { name: "全部订单", value: "all", count: 0 },
        wait_pay: { name: "待付款", value: "wait_pay", count: 0 },
        wait_delivery: { name: "待发货", value: "wait_delivery", count: 0 },
        wait_confirm: { name: "待收货", value: "wait_confirm", count: 0 },
        complete: { name: "已完成", value: "complete", count: 0 },
        commented: { name: "已评价", value: "commented", count: 0 },
        cancel: { name: "已取消", value: "cancel", count: 0 },
        service: { name: "售后中", value: "service", count: 0 },
      },
      order_list: [],
      is_popup_show: false,
      form_data_send: { ...form_data_send },
      form_data_tax:{
        order_id:'',
        type:1,
        title:'',
        tax_number:'',
        company_address:'',
        phone:'',
        bank_name:'',
        bank_account:'',
      },
      show_tax_form:false,
      temp_order_no:'',
      currTab:1,
      logistics,
      curr_order: "最新订单",
      orderby_list: [
        { name: "最新订单", value: "desc", order: "desc" },
        { name: "最早订单", value: "asc", order: "asc" },
      ],
    };
  },
  watch: {
    "form_data.status": function(newVal, oldVal) {
      this.form_data.status = newVal;
      this.page = 1;
      this.onGetMallOrderList();
    },
  },
  computed: {
    avatar() {
      return this.profile.avatar || require("@/assets/images/avatar.png");
    },
  },
  mounted() {
    this.change_status("all");
    axios
      .all([this.getProfile(),this.onGetMallOrderCount(), this.onGetMallOrderList(), this.getCateList()])
      .then(axios.spread(() => {}));
  },
  methods: {
    calcRemainDays,
    onApplyService(goods,order){
      console.log('goods',goods);
      console.log('order',order);
      if(order.status_text === 'service' || goods.has_service) {
      	if(goods?.service?.uuid) {
			this.$router.push({
				name:'ServiceDetail',
				query:{
					order_id:order.uuid,
					goods_id:goods.product_id,
					service_uuid:goods.service.uuid
				}
			})
		} else {
			this.$layer.msg(`请等待该单的售后申请完成再发起`);
		}
      }else{
        this.$router.push({
          name:'ServiceApply',
          query:{
            order_id:order.uuid,
            goods_id:goods.product_id,
			  og_uuid: goods.uuid
          }
        })
      }
    },
    onOrderEvaluate(uuid){
      this.$router.push({
        name:'MallOrderEvaluate',
        query:{
          uuid
        }
      })
    },
   async onGetMallOrderCount(){
      try{
        const {code,msg,data} = await MallOrderCount(this.form_data);
        if(code>0){
          this.$layer.msg(msg);
          return;
        }
        for(let key in this.status_list){
          this.status_list[key].count = data[key] || 0;
        }
      }catch(e){
        console.log('err-mall-order-count',e);
      }
   },
    async onGetMallOrderList(){
      try{
        this.order_list = []
        const params = { ...this.form_data, page: this.page, size: this.size };
        const res = this.form_data.status === 'service'
          ? await MallOrderServiceList(params)
          : await MallOrderList(params);
        const {code,msg,data} = res;
        if(code>0){
          this.$layer.msg(msg);
          return;
        }
        this.total = data.total;
        this.order_list = data.list;
        this.onGetMallOrderCount();
      }catch(e){
        console.log('err-mall-order-list',e);
      }
    },
    onChangeLogistics(){
      const {form_data_send} = this;
      if(form_data_send.logistics_name === '送货上门'){
        this.form_data_send.logistics_no = this.temp_order_no;
      }
      console.log('form_data_send',form_data_send);
    },
    onViewTax({status,tax_file}){
      if(status == 1){
        this.$layer.msg('发票开具中.请耐心等待...');
        return;
      }
      if(!tax_file || !tax_file.startsWith('http')){
        this.$layer.msg('发票文件异常,请联系客服');
        return;
      }
      window.open(tax_file,'_blank');
    },
    onApplyTax(data){
      console.log('data-apply-tax',data);
      this.form_data_tax.order_id = data.order_id;
      this.show_tax_form = true;
    },
    closeTaxForm(){
      this.form_data_tax = {
        order_id:'',
        type:1,
        title:'',
        tax_number:'',
        company_address:'',
        phone:'',
        bank_name:'',
        bank_account:'',
      }
      this.show_tax_form = false;
    },
    async saveTax(){
      try{
        const {form_data_tax} = this;
        console.log('form_data_tax',form_data_tax);
        await applyTax(form_data_tax);
        this.$layer.msg('申请开票成功,请耐心等待.');
        this.closeTaxForm();
        this.onGetMallOrderList();
      }catch(e){
        console.log('err-save-tax',e);
      }
    },
    showChat(v) {
      if(v.seller){
       this.$refs.chat.showChat(null, v.seller);
      } else {
        this.$refs.chat.showChat();
      }
    },
    save() {
      SendFabric(this.form_data_send)
        .then(() => {
          this.$layer.msg(`保存成功`);
          this.is_popup_show = false;
          this.form_data_send = { ...form_data_send };
          return this.onGetMallOrderList();
        })
        .catch((res) => {
          this.$layer.msg(res.msg);
        });
    },
    close() {
      this.is_popup_show = false;
    },
    onSubMeterials(data) {
      console.log('data-sub-meterials',data);
      const {uuid,order_no}  = data;
      this.form_data_send.uuid = uuid;
      this.temp_order_no = order_no;
      this.is_popup_show = true;
    },
    search() {
      this.onGetMallOrderList();
    },
    confirm(uuid) {
      this.$DModal.confirm({
        content: "该订单确认收货么？",
        onOK: () => {
          MallConfirmOrder({ uuid })
            .then(() => {
              this.$layer.msg(`操作成功`);
            })
            .finally(() => {
              this.onGetMallOrderList();
            });
        },
      });
    },
    cancel(uuid) {
      this.$DModal.confirm({
        content: "该订单确认取消么？",
        onOK: () => {
          MallCancelOrder({ uuid })
            .then(() => {
              this.$layer.msg(`操作成功`);
            })
            .finally(() => {
              this.onGetMallOrderList();
            });
        },
      });
    },
    pay({uuid}) {
      this.$router.push({
        name: "MallCheckOut",
        query: { uuid,from:'order-list' },
      });
      // this.$router.push({name: 'CashDesk', query: {uuid, pay_type: 'wechat'}})
    },
    makeup(uuid) {
      this.$router.push({
        name: "Makeup",
        query: { uuid, pay_type: "wechat" },
      });
    },
    oc(v) {
      return [v.status_text];
    },
        go2service(v) {
      this.$router.push({
        name: 'ServiceDetail',
        query: {
          order_id: v.ord && v.ord.uuid,
          goods_id: v.goods && v.goods.uuid,
          service_uuid: v.uuid
        }
      });
    },
    displayGoods(v) {
      if (this.form_data.status === 'service') {
        return v.goods ? [v.goods] : [];
      }
      return v.goods || [];
    },
    go2detail(uuid) {
      // console.log('暂未开放');
      // return;
      this.$router.push({ name: "OrderDetail", query: { uuid,from:'mall' } });
    },
    changePage(page) {
      this.page = page;
      this.onGetMallOrderList();
    },
    changeSize(size) {
      this.page = 1;
      this.size = size;
      this.onGetMallOrderList();
    },
    change_status(s) {
      this.form_data.status = s;
    },
    onOrderClick({ name, value }) {
      this.curr_order = name;
      this.form_data.order_type = value;
      this.page = 1;
      this.onGetMallOrderList();
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    async getCateList() {
      try {
        const { code, data } = await MallOrderCateList();
        if (code === 0) {
          this.cate_list = data;
        }
      } catch (e) {
        console.log('err-cate-list', e);
      }
    },
    onCateClick(id) {
      this.form_data.cate_id = id;
      this.curr_cate = id ? this.cate_list.find(item => item.id === id)?.name || '分类' : '全部分类';
      this.page = 1;
      this.onGetMallOrderList();
    },
  },
};
</script>

<style lang="scss" scoped>
.mall-order-center {
  width: 100%;
  .container {
    padding: 0 70px 0 30px;
    background: white;

    .status-list {
      position: relative;
      padding: 20px 0;
      display: flex;
      align-content: flex-start;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      flex-wrap: wrap;
      row-gap: 15px;
      .status-list-box {
        display: flex;
        flex-wrap: wrap;
        column-gap: 10px;
        row-gap: 10px;
      }
      .status-item {
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        text-align: center;
        flex-shrink: 0;
        cursor: pointer;
        padding: 0 15px;
        &.active {
          background: #fa3d5a;
          border-radius: 5px;
          color: white;
        }
        &:first-child {
          margin-left: 0;
        }
      }
      .filter-box {
        display: flex;
        align-items: center;
        column-gap: 10px;
        flex-wrap: wrap;
        row-gap: 10px;
        .filter-item {
          display: flex;
          align-items: center;
          justify-content: center;
          column-gap: 5px;
          border: 1px solid #f0f0f0;
          border-radius: 30px;
          padding: 5px 12px;
          font-size: 13px;
          cursor: pointer;
          white-space: nowrap;
          .cate-box {
            width: 100%;
            max-height: 300px;
            overflow-y: auto;
            &::-webkit-scrollbar {
              display: none;
            }
          }
          .item {
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &.active, &:hover {
              background: rgba(0,0,0,0.03);
            }
          }
        }
      }
      .search {
        position: relative;
        flex-shrink: 0;
        .icon-search {
          position: absolute;
          top: 15px;
          left: 15px;
          width: 18px;
          height: 18px;
        }
        .input {
          width: 220px;
          height: 40px;
          line-height: 40px;
          border-radius: 20px;
          padding-left: 45px;
          background: #f3f4f6;
          font-size: 13px;
          outline: none;
          border: none;
        }
      }
    }

    .list {
      padding: 10px 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .item {
        // width: 1500px;
        width: 100%;
        margin: 5px 0;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #ebedf2;
        cursor: pointer;
        color: #191a1c;
        overflow:hidden;
        .title {
          height: 42px;
          line-height: 42px;
          padding-left: 20px;
          color: #191a1c;
          background: #edeff2;
          border-top-left-radius:10px;
          border-top-right-radius:10px;
        }
        .th {
          display: flex;
          flex-wrap: nowrap;
          line-height: 52px;
          text-align: center;
          background: #f6f7fa;
          border-radius: 5px 5px 0px 0px;
          border: 1px solid #e3e3e3;
          color: #575859;
          font-size: 14px;
          overflow:hidden;
          .info {
            width: 730px;
          }
          .quantity {
            width: 200px;
          }
          .amount {
            width: 200px;
          }
          .status {
            width: 200px;
          }
          .action {
            width: 200px;
          }
        }
        .content {
          display: flex;
          flex-wrap: nowrap;
          text-align: center;
          align-items: center;
          .info {
            width: 730px;
            border-right: 1px solid #e3e3e3;
            .sub-info {
              display: flex;
              align-items:center;
              // height: 150px;
              padding: 10px;
              .left {
                .image {
                  width: 110px;
                  height: 110px;
                  object-fit: cover;
                }
              }
              .right {
                text-align: left;
                padding: 10px;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                .sub-name {
                  width: 100%;
                  color: #191a1c;
                  font-size: 14px;
                  font-weight: 500;
                }
                .sub-category {
                  width: 100%;
                  color: #666;
                  font-size: 14px;
                }
                .sub-size {
                  width: 100%;
                  color: #666;
                }
                .sub-quantity {
                  width: 100%;
                  color: #666;
                }
                .pre-sale-line{
                  width:100%;
                  margin-bottom:5px;
                  .pre-sale-box{
                    width:fit-content;
                    padding:2px 5px;
                    background:#F8F9FB;
                    border-radius:4px;
                    display:flex;
                    align-items:center;
                    column-gap:8px;
                    font-size:13px;
                    .pre-tag{
                      border:1px solid #ff5967;
                      color:#ff5967;
                      border-radius:4px;
                      padding:0px 7px;
                    }
                    .pre-delivery-time{
                      color:#333;
                    }
                  }
                }
                
                .product-btn-box{
                  display:flex;
                  align-items:center;
                  .after-sale-btn{
                    width:66px;
                    height:26px;
                    border:1px solid #e3e3e3;
                    border-radius:2px;
                    line-height:26px;
                    text-align:center;
                    color:#666;
                    font-size:13px;
                    cursor:pointer;
                  }
                }
              }
            }
          }
          .quantity {
            width: 200px;
            line-height: 150px;
            border-right: 1px solid #e3e3e3;
          }
          .amount {
            width: 200px;
            line-height: 150px;
            border-right: 1px solid #e3e3e3;
            font-weight: bold;
            font-size: 14px;
          }
          .status {
            width: 200px;
            line-height: 150px;
            border-right: 1px solid #e3e3e3;
            font-size: 14px;
            &.unpaid {
              color: #ff4400;
            }
            &.wait_delivery {
              color: #1572b8;
            }
            &.wait_confirm {
              color: #32a410;
            }
            &.cancel {
              color: #666666;
            }
            &.complete {
              color: #666666;
            }
          }
          .action {
            width: 200px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            row-gap: 5px;
            .btn {
              width: 80px;
              height: 35px;
              line-height: 35px;
              text-align: center;
              border-radius: 5px;
              font-size: 14px;
              margin: 0 5px;
              &.btn-pay {
                background: #fa3d5a;
                color: white;
              }
            }
            .btn-customer {
              color: #3c3c3c;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
::v-deep .popup-modal {
  h2 {
    padding: 10px 20px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #f0f0f0;
  }
  .form {
    padding: 10px 0;
    .form-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      align-items: center;
      margin-top: 20px;
      .form-label {
        width: 100px;
        font-size: 14px;
        color: #696a6a;
        text-align: right;
      }
      .form-control {
        position: relative;
        .input {
          width: 300px;
          height: 48px;
          line-height: 48px;
          border: 1px solid #d9d9d9;
          border-radius: 5px;
          padding: 0 10px;
          outline: none;
          font-size: 14px;
          &[readonly] {
            border: none;
          }
        }
      }
    }

    .btn-submit {
      margin: 40px 0 0 40px;
      width: 110px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #fa3d5a;
      color: white;
      border-radius: 6px;
      cursor: pointer;
    }
  }
}

.customer {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 200px;
  cursor: pointer;
}
</style>
